var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDontDropFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 34.66,
    d: "M411.654 307.434v-34.4c0-7.47-3.851-14.634-10.707-19.916l-121.631-93.717c-6.856-5.282-16.153-8.25-25.848-8.25h-131.05c-20.189 0-36.556 12.61-36.556 28.166v270.605c0 15.555 16.367 28.166 36.556 28.166h95.683",
    transform: "translate(6.91 -17.678) matrix(.9084 0 0 1.17896 16.798 -114.925)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 36.48,
    d: "M400.862 203.097h-94.329c-18.339 0-33.206-14.867-33.206-33.207V75.562",
    transform: "translate(6.91 -17.678) translate(-12.525 -9.879)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 36.48,
    d: "M307.712 431.045l117.054-117.054",
    transform: "translate(6.91 -17.678) translate(-6.91 17.678)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 36.48,
    d: "M307.712 431.045l117.054-117.054",
    transform: "translate(6.91 -17.678) matrix(-1 0 0 1 725.567 17.678)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontDropFile);
export default __webpack_public_path__ + "static/media/dont-drop-file.fc05619586889f44fe9fa166b2326186.svg";
export { ForwardRef as ReactComponent };